import { RecipeChip } from "./RecipeChip";
export default RecipeChip;
